import { Component, Input } from '@angular/core';

@Component({
    selector: 'category-debug',
    templateUrl: './category-debug.component.html',
    standalone: true,
})

/**
 * Componente para mostrar información de depuración de categorias
 */
export class CategoryDebugComponent {
    @Input() public info: string;

    @Input() public template: string;
}
